// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1_0E_","selected":"Chip_selected__2ZTRp"};